<template>
  <cumulus-info-dialog
    v-model="dialogInfo"
    icon="$chart"
    :title="$t('plane_stat')"
    :loading="loading"
    :max-width="1000"
    color="stat"
    dark
    activator-button
    @open="showPlaneStat"
    @escape="closeDialog"
  >
    <template v-slot:info>
      <v-row class="mx-2">
        <v-col
          cols="12"
          md="6"
        >
          <date-field
            v-model="range.start"
            field-name="range_start_date"
            rules="date"
            autofocus
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <date-field
            v-model="range.end"
            field-name="range_end_date"
            rules="date"
          />
        </v-col>
      </v-row>

      <v-skeleton-loader
        v-if="!planeStat"
        type="table"
      />
      <v-container v-else>
        <v-data-table
          :headers="stat_headers"
          :items="planeStat"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :loading="loading"
          item-key="reg_num"
          show-expand
          dense
          class="elevation-1"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="blue lighten-1 px-3">
              <div
                v-for="(row, i) in item.stat"
                :key="i"
              >
                <v-row
                  class="font-weight-medium white--text py-0 mt-0"
                >
                  <v-col class="pl-16 ml-10">
                    {{ row.month }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ row.winch }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ row.tow }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ row.landing }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ row.counter }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ row.flight_time }}
                  </v-col>
                </v-row>
                <v-row
                  v-for="(day, d) in row.dailyStat"
                  :key="d"
                  class="font-weight-medium gray--text blue lighten-5 my-0"
                >
                  <v-col class="pl-16 ml-10">
                    {{ day.day }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ day.winch }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ day.tow }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ day.landing }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ day.counter }}
                  </v-col>
                  <v-col class="px-4" style="max-width: 150px;">
                    {{ day.flight_time }}
                  </v-col>
                </v-row>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-container>
    </template>
  </cumulus-info-dialog>
</template>

<script>

  import { call } from 'vuex-pathify'
  import { startOfYear, endOfYear, format } from 'date-fns'

  export default {
    name: 'PlaneStat',
    props: {
      planeId: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialogInfo: false,
        expanded: [],
        singleExpand: true,
        planeStat: null,
        loading: false,
        timer: null,
        range: {
          start: format(startOfYear(new Date()), 'yyyy-MM-dd'),
          end: format(endOfYear(new Date()), 'yyyy-MM-dd'),
        },
      }
    },
    computed: {
      stat_headers () {
        return [
          {
            text: this.$t('fields.plane'),
            value: 'reg_num',
          },
          {
            text: this.$t('fields.winch'),
            value: 'winch',
            width: 150,
          },
          {
            text: this.$t('fields.tow'),
            value: 'tow',
            width: 150,
          },
          {
            text: this.$t('fields.landing'),
            value: 'landing',
            width: 150,
          },
          {
            text: this.$t('fields.counter'),
            value: 'counter',
            width: 150,
          },
          {
            text: this.$t('flight_time'),
            value: 'flight_time',
            width: 150,
          },
        ]
      },
    },
    watch: {
      dialogInfo (val) {
        val || this.closeDialog()
      },
      range: {
        handler () {
          if (this.timer) {
            clearTimeout(this.timer)
            this.timer = null
          }
          this.timer = setTimeout(() => {
            this.showPlaneStat()
          }, 800)
        },
        deep: true,
      },
    },
    mounted () {
      /* UploadService.getFiles().then((response) => {
        this.fileInfos = response.data
      }) */
    },
    methods: {
      getPlaneStat: call('plane/stat'),
      async showPlaneStat () {
        console.log('showPlaneStat')
        this.loading = true
        await this.getPlaneStat({ range: this.range, plane_id: this.planeId }).then(response => {
          this.planeStat = response
          this.dialogInfo = true
          this.loading = false
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      },
      closeDialog () {
        this.dialogInfo = false
        this.planeStat = null
      },
    },
  }
</script>

<style lang="sass">
.v-dialog
  .v-card
    display: flex !important
    flex-direction: column

  .v-card__text
    flex-grow: 1
    overflow: auto
    // max-height: calc(100vh - 500px)
</style>
